import { mediaList } from '../constants';
import myFetch from '../helpers/myFetch';
import {errorActions} from './errorDisplay.actions';

export function fetchMediaList() {
  return dispatch => {
    dispatch(requestMediaList())
    // 拿到來源中所有的網站 2020 10 06
    return myFetch(false, true, true)('/v5/lowi3/q/get_type_source', {})
      .then(json => { dispatch(receiveMediaList(json)) })
      .catch(err => {
        dispatch(errorActions.update(err))
        }
      )
  }
}

function requestMediaList() {
  return {
    type: mediaList.REQUEST,
  }
}
function mediaListErrorShow(err) {
  return {
    type: mediaList.SHOWE_ERROR,
    mediaListError: true,
  };
}
export function mediaListErrorCLean() {
  return {
    type: mediaList.CLEAN_ERROR,
    mediaListError: false,
  };
}

// 整理資料架構
const cleanData = (json) => {
  if (json && json.response_status==='SUCCESS') {
    const value = json.value ? json.value : [];
    let bbsList = {},
        blogList = {},
        newsList = {},
        smList = {};

    for (let i = 0; i < value.length; i++) {
      let mediaType = value[i]['@value'];
      let mediaSources = [];
      for (let j = 0; j < value[i].field.length; j++) {
        const source = value[i].field[j]['@value'];
        mediaSources.push({ value: source, label: source})
      }
      switch (mediaType) {
        case 'BBS': bbsList = mediaSources; break;
        case 'BLOG': blogList = mediaSources; break;
        case 'NEWS': newsList = mediaSources; break;
        case 'SM': smList = mediaSources; break;
        default: break;
      }
    }

    return { bbsList, blogList, newsList, smList };
  }
  else {
    return null;
  }
}
function receiveMediaList(json) {
  const medias = cleanData(json);
    return {
      type: mediaList.RECEIVE,
      bbsList: medias.bbsList,
      blogList: Object.values(medias.blogList).length >0 ? medias.blogList:medias.bbsList,
      newsList: medias.newsList,
      smList: medias.smList
    };
}



// WEBPACK FOOTER //
// ./src/actions/mediaList.actions.js